import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Lock, AlertCircle, ArrowRight } from 'lucide-react';
export function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email || !password) {
      setError('Please fill in all fields.');
      return;
    }
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      // In a real app, redirect to /app here
      window.location.href = '/app';
    }, 1000);
  };
  return <div className="min-h-screen bg-slate-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8 font-sans animate-in fade-in duration-500" data-id="element-675" data-mp="4fza0mw2icop">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-676" data-mp="2a9plg2klwmil">
        <div className="flex justify-center" data-id="element-677" data-mp="267m7n7agt5u5">
          <div className="w-10 h-10 bg-slate-900 rounded-md" data-id="element-678" data-mp="268ngd540dg8p"></div>
        </div>
        <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-slate-900" data-id="element-679" data-mp="v4bhnufj8gss">
          Sign in to your account
        </h2>
        <p className="mt-2 text-center text-sm text-slate-600" data-id="element-680" data-mp="150y1qh01b3tr">
          Or{' '}
          <Link to="/register" className="font-medium text-slate-900 hover:underline" data-id="element-681" data-mp="19reh46nf0zir">
            create a new account
          </Link>
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-682" data-mp="1esu6uc0jfu7h">
        <div className="bg-white py-8 px-4 shadow-sm border border-slate-200 sm:rounded-xl sm:px-10" data-id="element-683" data-mp="1iqi0zcuepiyb">
          <form className="space-y-6" onSubmit={handleSubmit} data-id="element-684" data-mp="1nrp95d0gok5i">
            {error && <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-md text-sm flex items-start" data-id="element-685" data-mp="1soxwrt4dpge5">
                <AlertCircle className="h-5 w-5 mr-2 shrink-0 mt-0.5" data-id="element-686" data-mp="3pkn8zssnoczy" />
                <span data-id="element-687" data-mp="3uif0wmtavz45">{error}</span>
              </div>}

            <div data-id="element-688" data-mp="3mgee4gr9w5iq">
              <label htmlFor="email" className="block text-sm font-medium text-slate-700" data-id="element-689" data-mp="3mhz5xym7dacw">
                Email address
              </label>
              <div className="mt-1 relative rounded-md shadow-sm" data-id="element-690" data-mp="9zkyuy2zgc8">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-691" data-mp="3rg0s4sexdpsl">
                  <Mail className="h-4 w-4 text-slate-400" data-id="element-692" data-mp="9a5wwce4s89a" />
                </div>
                <input id="email" name="email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm" placeholder="you@example.com" data-id="element-693" data-mp="981ih0ilvqur" />
              </div>
            </div>

            <div data-id="element-694" data-mp="17mf0xchft7hw">
              <label htmlFor="password" className="block text-sm font-medium text-slate-700" data-id="element-695" data-mp="17lvhtsg1wd2a">
                Password
              </label>
              <div className="mt-1 relative rounded-md shadow-sm" data-id="element-696" data-mp="xmee3gkd098y">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-697" data-mp="12lhh6vgs45ea">
                  <Lock className="h-4 w-4 text-slate-400" data-id="element-698" data-mp="nwusw496c3ax" />
                </div>
                <input id="password" name="password" type="password" autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} className="block w-full pl-10 pr-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-slate-900 sm:text-sm" placeholder="••••••••" data-id="element-699" data-mp="snl1rrgt6oad" />
              </div>
            </div>

            <div className="flex items-center justify-between" data-id="element-700" data-mp="1da266zvzzw74">
              <div className="flex items-center" data-id="element-701" data-mp="189oa8g7o8cpg">
                <input id="remember-me" name="remember-me" type="checkbox" className="h-4 w-4 text-slate-900 focus:ring-slate-900 border-slate-300 rounded" data-id="element-702" data-mp="13i683otww62w" />
                <label htmlFor="remember-me" className="ml-2 block text-sm text-slate-700" data-id="element-703" data-mp="tl1nhtfpsio7">
                  Remember me
                </label>
              </div>

              <div className="text-sm" data-id="element-704" data-mp="kjtvtu7peg33">
                <Link to="/forgot-password" className="font-medium text-slate-900 hover:underline" data-id="element-705" data-mp="fl0jw682ex51">
                  Forgot your password?
                </Link>
              </div>
            </div>

            <div data-id="element-706" data-mp="29zb6s953nh86">
              <button type="submit" disabled={isLoading} className="w-full flex justify-center items-center py-2.5 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-slate-900 hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-900 disabled:opacity-70 transition-colors" data-id="element-707" data-mp="29wp34klbxlv8">
                {isLoading ? 'Signing in...' : 'Sign in'}
                {!isLoading && <ArrowRight className="ml-2 h-4 w-4" data-id="element-708" data-mp="1ykzrower6jd5" />}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>;
}